import SvgIcon from "@mui/material/SvgIcon";

interface FieldsIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function AnimalGroupLocationIcon({
  htmlColor,
  fontSize = "medium",
}: FieldsIconProps) {
  return (
    <SvgIcon viewBox="0 0 14 14" fontSize={fontSize} width="14" height="14">
      <path
        stroke={htmlColor || "currentColor"}
        d="M6.99969 7.83336C8.00485 7.83336 8.81969 7.01852 8.81969 6.01336C8.81969 5.0082 8.00485 4.19336 6.99969 4.19336C5.99453 4.19336 5.17969 5.0082 5.17969 6.01336C5.17969 7.01852 5.99453 7.83336 6.99969 7.83336Z"
        stroke-width="0.875"
        fill="none"
      />
      <path
        stroke={htmlColor || "currentColor"}
        d="M2.11231 4.95185C3.26148 -0.0998164 10.7456 -0.093983 11.889 4.95768C12.5598 7.92102 10.7165 10.4294 9.10064 11.981C7.92814 13.1127 6.07314 13.1127 4.89481 11.981C3.28481 10.4294 1.44148 7.91518 2.11231 4.95185Z"
        stroke-width="0.875"
        fill="none"
      />
    </SvgIcon>
  );
}
